module.exports = __webpack_public_path__ + "static/media/upload - Copy.a23b9a9e.jpg";